// extracted by mini-css-extract-plugin
module.exports = {"products":"suggestedProducts_products__YyCIH","item":"suggestedProducts_item__2maVW","root":"suggestedProducts_root__y3MV-"};